import { render, staticRenderFns } from "./Page020.vue?vue&type=template&id=ee49da94&scoped=true&"
import script from "./Page020.vue?vue&type=script&lang=js&"
export * from "./Page020.vue?vue&type=script&lang=js&"
import style0 from "./Page020.vue?vue&type=style&index=0&id=ee49da94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee49da94",
  null
  
)

export default component.exports